import { Attr, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class XeroContact extends ApplicationRecord {
  static jsonapiType = "xero_contacts";

  @Attr() guid: string;

  @Attr() name: string;

  @HasMany() organisation: Organisation;
}

export default XeroContact;
